import useModal from 'antd/es/modal/useModal/index';
export default useModal;
